<style lang="scss">
.group-chat-select {
  .btn-select {
    padding: 20px;
  }
}
.groupchatselect-modal {
  .el-dialog__body {
    padding: 0 20px;
  }
  .select-container {
    display: flex;
    background: #f2f2f2;
    // padding: 20px;
    border: 1px solid $color-border-gray-light;
    border-radius: 6px;
    .group-list {
      flex: 1;
      padding: 20px;
      height: 500px;
      border-right: 1px solid $color-border-gray-light;
      .hd {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .bd {
        @include clearfix();
        margin-top: 10px;
        height: 370px;
        .bd-item {
          float: left;
          padding: 4px 10px;
          background: #fff;
          margin: 0 10px 10px 0;
          width: 120px;
          border-radius: 2px;
          position: relative;
          &.active {
            &:after {
              content: '已选择';
              display: block;
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              left: 0;
              background: rgba(0, 0, 0, 0.55);
              color: #fff;
              text-align: center;
              line-height: 48px;
            }
          }
          &:nth-child(5n) {
            margin-right: 0;
          }
          .name {
            @include text-overflow();
            height: 20px;
            font-size: 13px;
          }
          .owner {
            @include text-overflow();
            height: 20px;
            font-size: 12px;
            color: $color-hint-text;
          }
        }
      }
      .ft {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
        .ft-desc {
          font-size: 13px;
          color: $color-hint-text;
        }
      }
      .search-input {
        width: 260px;
      }
    }
    .group-select {
      width: 276px;
      padding: 20px;
      .hd {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .bd {
        margin: 10px 0;
      }
      .select-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 13px;
        .el-button {
          padding: 6px 20px;
          font-size: 13px;
        }
      }
    }
  }
  .dialog-footer {
    .el-button {
      &:not(:last-child) {
        margin-right: 10px;
      }
    }
  }
}
</style>
<template>
  <div class="group-chat-select">
    <div
      class="btn-select"
      @click="handleToggleModal"
    >
      添加导购以筛选
    </div>
    <slot />
    <el-dialog
      class="groupchatselect-modal"
      title="选择群聊"
      :visible="showModal"
      :show-close="false"
      width="1000px"
      modal-append-to-body
      append-to-body
      destroy-on-close
      top="5vh"
    >
      <div class="select-container">
        <div class="group-list">
          <div class="hd">
            <el-checkbox
              v-model="checked"
              @change="selectAll"
            >
              选择本页所有群聊
            </el-checkbox>
            <el-input
              v-model="keyword"
              class="search-input"
              placeholder="请输入群聊名称"
              @change="seachByKeyword"
            >
              <template slot="append">
                <div @click="seachByKeyword">
                  搜索
                </div>
              </template>
            </el-input>
          </div>
          <div class="bd">
            <div
              v-for="(item, index) in list"
              :key="`bd-item__${index}`"
              class="bd-item"
              :class="{ active: isActive(item) }"
              @click="handleSelect(item)"
            >
              <div class="name">
                {{ item.name }}
              </div>
              <div class="owner">
                {{ `群主: ${item.owner}` }}
              </div>
            </div>
          </div>
          <div class="ft">
            <div class="ft-desc">
              共{{ pageCount }}个群聊，已显示第1-20个群聊
            </div>
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="pageSize"
              :total="pageCount"
              @current-change="onChangePage"
            />
          </div>
        </div>
        <div class="group-select">
          <div class="hd">
            <div>已选群聊</div>
            <div>共{{ select.length }}个群聊</div>
          </div>
          <div class="bd">
            <div
              v-for="(item, index) in select"
              :key="`select-item__${index}`"
              class="select-item"
            >
              <span>{{ item.name }}</span>
              <el-button
                type="text"
                @click="deleteItem(index)"
              >
                删除
              </el-button>
            </div>
          </div>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="medium"
          @click="handlecloseModal"
        >取 消</el-button>
        <el-button
          type="primary"
          size="medium"
          @click="handleComfirmModal"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageMixin from './mixins/page'
export default {
  name: 'SpGroupChatPicker',
  mixins: [PageMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isShow: Boolean
  },
  data () {
    const { data } = this.value
    return {
      showModal: false,
      keyword: '',
      list: [],
      select: data,
      checked: false
    }
  },
  watch: {
    isShow: {
      immediate: true,
      handler (val) {
        this.showModal = val
      }
    }
  },
  mounted () {
    this.refresh()
  },
  methods: {
    async fetch ({ page_no, page_size }) {
      let params = {
        page: page_no,
        page_size
      }
      if (this.keyword) {
        params = {
          ...params,
          chat_name: this.keyword
        }
      }
      const { list, total_count } = await this.$api.salesperson.customerBaseGetList(params)
      this.list = list
      return {
        count: total_count
      }
    },
    handlecloseModal () {
      this.showModal = false
      this.$emit('close')
    },
    handleToggleModal () {
      this.showModal = true
    },
    handleComfirmModal () {
      this.$emit('input', { data: this.select })
      this.showModal = false
    },
    // 选择
    handleSelect (item) {
      const fd = this.select.find((v) => v.id == item.id)
      if (fd) {
        const index = this.select.findIndex((v) => v.id == item.id)
        this.select.splice(index, 1)
      } else {
        this.select.push(item)
      }
    },
    isActive (item) {
      return this.select.find((v) => v.id == item.id)
    },
    // 删除
    deleteItem (index) {
      this.select.splice(index, 1)
    },
    selectAll (e) {
      if (e) {
        this.select = this.list.map((item) => {
          return item
        })
      } else {
        this.select = []
      }
    },
    onChangePage (p) {
      console.log('p: ', p)
      this.goPage(p)
    },
    seachByKeyword () {
      this.refresh(true)
    }
  }
}
</script>
